import {IRouteChanged, subscribeToRouteChanged} from "../eventBus/route/routeEventBus";
import {appRoutePaths} from "../../config/config";
import {withDisplayErrorToUser} from "../error/error";
import playgroundApi from "../playgroundApi";
import {createCourseLessonsPageViewModel, createInitialViewModel} from "../../factories/courseLessonsPageFactory";
import ICourseLessonsPage from "../../models/view/courseLessonsPage/ICourseLessonsPage";
import {createEventBusAndHook} from "../eventBus/common";
import ICard from "../../models/view/common/ICard";
import settingsService from "../settings/settingsService";
import {navigate} from "../navigation/navigation";

export const initialCourseLessonsPageViewModel = createInitialViewModel();

export const {
  subscribe: subscribeToCourseLessonPageViewModelChanged,
  emitMessage: courseLessonPageViewModelChanged,
  use: useCourseLessonsPageViewModel
} = createEventBusAndHook<ICourseLessonsPage>(initialCourseLessonsPageViewModel);

class CourseLessons{
  // Array of unsubscribe functions to call when this instance is destroyed.
  unsubscribeFuncs: (() => void)[] = [];
  courseLessonsPageViewModel = initialCourseLessonsPageViewModel;
  constructor(){
    this.unsubscribeFuncs = [
      subscribeToRouteChanged(this.handleRouteChange.bind(this)),
    ];
  }
  destroy(){
    this.unsubscribeFuncs.forEach(u => u());
  }

  async handleRouteChange({routePath, locationPath, search: _search, userHasValidToken}: IRouteChanged){
    if(appRoutePaths.courseLessonsPage !== routePath || !userHasValidToken){ return; }
    const {courseId} = getCoursesCourseIdFromLocationPath(locationPath);
    await this.loadCourseLessonsViewModel(courseId);
  }

  async loadCourseLessonsViewModel(courseId: number | undefined){
    return withDisplayErrorToUser(async ()=>{
      if(courseId === undefined){ throw new Error(`A valid course id must be supplied to view the course's lessons. `); }
      const myCourseResponse = await playgroundApi.myCourse({courseId});

      // Auto display info modal the first time user visits the page.
      const hasModalBeenDisplayedForTheFirstTime = settingsService.getHasModalForCourseIdBeenDisplayed(courseId);
      settingsService.markCourseModalForCourseIdAsDisplayed(courseId);

      this.courseLessonsPageViewModel = createCourseLessonsPageViewModel(myCourseResponse, courseId, hasModalBeenDisplayedForTheFirstTime);
      courseLessonPageViewModelChanged(this.courseLessonsPageViewModel);
    });
  }
}

function getCoursesCourseIdFromLocationPath(locationPath: string,){
  const parts = locationPath.split("/"); //should result in ["", "courses", "35", ]
  let courseId;
  if(parts.length >= 3){
    const courseIdParsed = parseInt(parts[2]);
    courseId = isNaN(courseIdParsed) ? undefined : courseIdParsed;
  }
  return {courseId};
}


export function cardClicked(card: ICard){
  navigate(card.relativeUrl);
}

const courseLessons = new CourseLessons();
export default courseLessons;